import http from 'plugins/axios';

export default {
    // 获取登录/注册开关内容
    getAuthApplyCount() {
        return http.get({
            url: '/admin/auth/switch/zh/info'
        });
    },
    updateZHStatus(data) {
        return http.post({
            url: '/admin/auth/switch/updateZHStatus',
            data: data,
            dataType: 'form'
        });
    }
};
